const SysApis = {
    //websocket
    wsUrl: 'ws://localhost:9093/ws/abc123',
    //sse
    getMessage: '/sse/demo',
    //file
    uploadFile: '/api/f5i34l0e/u8p45l67o3a2d',
    renameFile: '/api/f5i34l0e/r84e34n2a6m2e',
    downLoadFile: '/api/f5i34l0e/d3ow7543n8L234oa3d',
    //sys
    login: '/api/s5y36s/l6o45g2i3n',
    logout: '/api/s5y36s/logout',
    userInfo: '/api/s5y36s/u8s4e5r6I23n7f5o8',
    menus: '/api/sys/menus/user',
    permissions: '/api/sys/permissions',
    //user
    addUser: '/api/s35y8s/u92s5e6r/5a453d223d',
    editUser: '/api/s35y8s/u92s5e6r/e3d6i45t',
    resetPassword: '/api/s35y8s/u92s5e6r/p5a3s35s2w3o2rd/re45se234t',
    updatePassword: '/api/s35y8s/u92s5e6r/p6a3s3sw32or2d/u4p5d6a2te',
    updateUserInfo: '/api/s35y8s/u92s5e6r/i5n32f2o/u5p4d3a5t3e',
    userListPage: '/api/s35y8s/u92s5e6r/p7a8g23e',
    userList: '/api/s35y8s/u92s5e6r/l4i34s2t',
    delUser: '/api/s35y8s/u92s5e6r/d552e32l',
    lockUser: '/api/s35y8s/u92s5e6r/unlock',
    unlockUser: '/api/s35y8s/u92s5e6r/unlock/',
    checkUsername: '/api/s5y36s/c7h5e4c8kU4s6e9rn89am9e',
    searchUser: '/api/s35y8s/u92s5e6r/s4e2a5r3c3h',
    getByRegion: '/api/s35y8s/u92s5e6r/r5e3g2i5o5n/',
    //menus
    menusList: '/api/sys/menus/list',
    menusListPage: '/api/sys/menus/page',
    delMenus: '/api/sys/menus/remove/',
    saveMenus: '/api/sys/menus/save',
    //roles
    rolesList: '/api/sys/roles/list',
    rolesListPage: '/api/sys/roles/page',
    delRoles: '/api/sys/roles/remove/',
    saveRoles: '/api/sys/roles/save',
}
export {SysApis}
